/* eslint-disable jsx-a11y/anchor-is-valid */

import { useContext, useEffect, useState } from 'react';
import CircularProducts from './CircularProducts';
import Circular from './Circular';
import axiosPrivate from '../../../hooks/axiosPrivate';
import LoaderContext from '../../../context/loader/LoaderContext';
import styles from '../Dealer/dealer.module.css';
import AssignDealer from './AssignDealer';

const tabs = [
  { name: 'Circular', value: 'circular' },
  { name: 'Circular Wise Product Rates', value: 'products' },
  { name: 'Assign Circular to Dealer', value: 'circular-dealer' },
];

const AssignRates = () => {
  const [currentTab, setCurrentTab] = useState('circular');
  const [circularList, setCircularList] = useState([]);
  const { setIsLoading, isLoading } = useContext(LoaderContext);

  const fetchCircular = async () => {
    try {
      setIsLoading(true);
      const response = await axiosPrivate.get('circular');
      setCircularList(response?.data || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching circular:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCircular();
  }, []);

  console.log('circularList', circularList);

  return (
    <div>
      {isLoading && <div className={styles.overlayMessage}>Loading...</div>}
      <div className='section-body'>
        <div className='container-fluid'>
          <div className='mb-4'>
            <ul className='nav nav-tabs fs-20 fw-bold'>
              {tabs.map((tab) => (
                <li className='nav-item' key={tab.name}>
                  <a
                    className={`nav-link text-dark ${
                      currentTab === tab.value
                        ? 'active text-primary fw-bolder'
                        : 'text'
                    }`}
                    onClick={() => {
                      setCurrentTab(tab.value);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {tab.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {currentTab === 'circular' && (
            <Circular circulars={circularList} fetchCircular={fetchCircular} />
          )}
          {currentTab === 'products' && (
            <CircularProducts circulars={circularList} />
          )}

          {currentTab === 'circular-dealer' && <AssignDealer circulars={circularList} />}
        </div>
      </div>
    </div>
  );
};

export default AssignRates;
